const corporateHotel = {
  // page.tsx
  'corporateHotel.page.lastUpdated': 'Last updated: 13 June 2026',
  'corporateHotel.page.backToTop': 'Back to top',

  // JSON-LD
  'corporateHotel.jsonld.serviceName': 'Hospitality Training for Hotels & Ryokan — Establishing Butler Service Standards',
  'corporateHotel.jsonld.orgName': 'The All Japan Butler Association',
  'corporateHotel.jsonld.serviceType': 'Hotel Hospitality Training',
  'corporateHotel.jsonld.areaServed': 'Japan',
  'corporateHotel.jsonld.description': 'Butler-method hospitality training for hotels and ryokan. Pre-opening intensive available. Full-day from JPY 330,000 (tax incl.). \n\nNationwide on-site delivery. Establish guest-room service standards quickly using the same methods used to train professional butlers.',
  'corporateHotel.jsonld.breadcrumb1': 'Home',
  'corporateHotel.jsonld.breadcrumb2': 'Corporate Training',
  'corporateHotel.jsonld.breadcrumb3': 'Hotels & Ryokan',

  // HeroSection
  'corporateHotel.hero.homeLink': 'Home',
  'corporateHotel.hero.corporateLink': 'Corporate Training',
  'corporateHotel.hero.currentPage': 'Hotels & Ryokan',
  'corporateHotel.hero.title': 'Corporate Training for Hotels & Ryokan',
  'corporateHotel.hero.titleEn': 'FOR HOTELS & RYOKAN',
  'corporateHotel.hero.lead': 'Our hotel and ryokan training programme uses butler-education methods to establish butler service and guest-room service standards quickly.',
  'corporateHotel.hero.ctaBtn': 'Enquire for This Sector',
  'corporateHotel.hero.imgAlt': 'A Japanese butler serving welcome tea in a luxury suite',
  'corporateHotel.hero.badge1': 'Establishing Suite & Club Lounge Standards',
  'corporateHotel.hero.badge2': 'On-site Training in Your Property',
  'corporateHotel.hero.badge3': 'The Same Instructors Who Train Our Butler Students',

  // PainPoints
  'corporateHotel.pain.label': 'CHALLENGES',
  'corporateHotel.pain.title': 'Do Any of These Challenges Sound Familiar?',
  'corporateHotel.pain.subtitleEn': 'Common Challenges',
  'corporateHotel.pain.lead': 'Butler-education methods address the service challenges specific to hotels and ryokan.',
  'corporateHotel.pain.item1': 'We are opening or refurbishing and need butler or club lounge service standards, but we have no one in-house to teach them',
  'corporateHotel.pain.item2': 'Expectations among overseas VIPs and inbound high-net-worth guests have risen, and our current service is no longer meeting the mark',
  'corporateHotel.pain.item3': 'Service quality varies between staff members, and the difference shows in guest satisfaction scores',
  'corporateHotel.pain.item4': 'Service standards have never been documented, so quality drops whenever staff change',

  // WhyButlerWorks
  'corporateHotel.why.label': 'WHY BUTLER TRAINING',
  'corporateHotel.why.title': 'Why Butler Training Works for Hotels',
  'corporateHotel.why.subtitleEn': 'Why Butler Training Works',
  'corporateHotel.why.lead': 'Butler training is the original source of butler service — and it aligns precisely with the reproducible standards hotels demand.',
  'corporateHotel.why.item1.title': 'The Origin of Butler Service',
  'corporateHotel.why.item1.desc': 'Butler education is a systematic body of skills built around devoting oneself entirely to a single guest — the original model for butler service. \n\nFrom bearing and movement to anticipatory preparation, everything a butler needs is acquired through one consistent, principled method.',
  'corporateHotel.why.item2.title': 'Two Parts Theory, Eight Parts Practice',
  'corporateHotel.why.item2.desc': 'Training focuses on physical movement drills designed around guest rooms and lounges. By repeating each action until the body moves instinctively — not just the mind understanding — participants can reproduce the standard from the very next shift.',
  'corporateHotel.why.item3.title': 'Service Standards You Can Pass On',
  'corporateHotel.why.item3.desc': 'The strength of butler education is its ability to articulate why each movement matters — not relying on intuition or unspoken experience. \n\nWe document the standards in written form so your property can use them to train and assess staff long after the session ends.',

  // RecommendedPrograms
  'corporateHotel.programs.label': 'RECOMMENDED PROGRAMMES',
  'corporateHotel.programs.title': 'Recommended Plans',
  'corporateHotel.programs.subtitleEn': 'Recommended for Hotels',
  'corporateHotel.programs.lead': 'Choose the plan that best fits the situation and goals of your property.',
  'corporateHotel.programs.recommended': 'Recommended',
  'corporateHotel.programs.currency': 'JPY (tax incl.)',
  'corporateHotel.programs.ctaBtn': 'Enquire About This Plan',
  'corporateHotel.programs.detailNote': 'Full module details are available on the',
  'corporateHotel.programs.detailLink': 'Corporate Training page',
  'corporateHotel.programs.detailSuffix': '.',
  'corporateHotel.programs.p1.title': 'Half-Day Example',
  'corporateHotel.programs.p1.duration': '3 hours',
  'corporateHotel.programs.p1.modules': 'M1 (Bearing & Movement) + M3 (Tea & Table Service — Practical)',
  'corporateHotel.programs.p1.desc': 'A focused short-form plan concentrating on the core movements of butler service and tea service. Well suited as a post-opening refresher or as a first step introduction to the programme.',
  'corporateHotel.programs.p2.title': 'Full-Day Example',
  'corporateHotel.programs.p2.duration': '6 hours',
  'corporateHotel.programs.p2.modules': 'M1 + M2 (VIP Guest Service Principles) + M3 + M4 (Handling the Unexpected — Role-play)',
  'corporateHotel.programs.p2.desc': 'Our recommended plan — covering bearing, VIP service, and role-play in a single day to give participants the complete foundation of butler-standard service.',
  'corporateHotel.programs.p3.title': 'Pre-Opening Intensive (3 Days)',
  'corporateHotel.programs.p3.duration': '18 hours (3 days)',
  'corporateHotel.programs.p3.modules': 'All 6 modules + a full run-through using your actual floor plan',
  'corporateHotel.programs.p3.desc': 'A concentrated programme designed specifically for pre-opening preparation. \n\nAfter completing all modules, participants conduct a full rehearsal using the actual routes in your guest rooms and lounges, so that consistent butler service is in place from day one.',

  // ScenarioTraining
  'corporateHotel.scenario.note': '* Scenarios can be tailored to the specific layout and facilities of your property.',
  'corporateHotel.scenario.label': 'SCENARIO TRAINING',
  'corporateHotel.scenario.title': 'Scenario Training',
  'corporateHotel.scenario.subtitleEn': 'Hotel Scenarios',
  'corporateHotel.scenario.lead': 'Three scenarios modelled on real hotel situations deepen practical skills.',
  'corporateHotel.scenario.s1.title': 'Welcome Tea in the Suite',
  'corporateHotel.scenario.s1.desc': 'Participants repeatedly practise the complete sequence — from escorting guests to the room at check-in, through holding and placing the tray, orienting the teacup, pouring, and withdrawing — in a room-setting simulation. \n\nThe session also covers handling luggage and coats, developing the quiet, purposeful movement that suite service demands.',
  'corporateHotel.scenario.s2.title': 'In-Room Dining',
  'corporateHotel.scenario.s2.desc': 'Every stage of in-room dining is rehearsed practically: manoeuvring and stopping the trolley, table setup, presenting and serving the meal, reading the timing for clearance. \n\nThe exercises make it tangible how accumulating small, precise actions is what shapes guest satisfaction.',
  'corporateHotel.scenario.s3.title': 'Welcoming a VIP Guest',
  'corporateHotel.scenario.s3.desc': 'Participants role-play the full arrival journey — from the first words at the porte-cochère, through escorting to the lift, to introducing the room on arrival. \n\nThe training focuses on when to speak, appropriate distance, and how to receive luggage, developing the conduct that makes a guest feel: "I can trust this hotel."',

  // TargetRoles
  'corporateHotel.roles.label': 'TARGET ROLES',
  'corporateHotel.roles.title': 'Who Should Attend',
  'corporateHotel.roles.subtitleEn': 'Who Should Attend',
  'corporateHotel.roles.lead': 'This programme is particularly recommended for the following roles.',
  'corporateHotel.roles.capacity': 'Recommended: up to 12 participants',
  'corporateHotel.roles.capacityNote': 'For larger groups, we can arrange two parallel groups or multiple sessions. On-site delivery in your guest rooms or lounge is available.',
  'corporateHotel.roles.r1': 'Butler',
  'corporateHotel.roles.r2': 'Concierge',
  'corporateHotel.roles.r3': 'Club Lounge Staff',
  'corporateHotel.roles.r4': 'Food & Beverage Service',
  'corporateHotel.roles.r5': 'Front Desk',
  'corporateHotel.roles.r6': 'Room Attendant',
  'corporateHotel.roles.r7': 'New Employee Training Coordinator',

  // PricingTable
  'corporateHotel.pricing.label': 'PRICING',
  'corporateHotel.pricing.title': 'Pricing Plans',
  'corporateHotel.pricing.subtitleEn': 'Transparent Pricing',
  'corporateHotel.pricing.lead': 'All prices are inclusive of consumption tax. Choose the plan that best fits your property\'s budget and objectives.',
  'corporateHotel.pricing.header.plan': 'Plan',
  'corporateHotel.pricing.header.duration': 'Duration',
  'corporateHotel.pricing.header.price': 'Fee (tax incl.)',
  'corporateHotel.pricing.header.note': 'Content',
  'corporateHotel.pricing.recommended': 'Standard',
  'corporateHotel.pricing.currency': 'JPY',
  'corporateHotel.pricing.plan1.name': 'Half-Day',
  'corporateHotel.pricing.plan1.duration': '3 hours',
  'corporateHotel.pricing.plan1.note': 'Choose 2 modules',
  'corporateHotel.pricing.plan2.name': 'Full Day',
  'corporateHotel.pricing.plan2.duration': '6 hours',
  'corporateHotel.pricing.plan2.note': 'Choose 4 modules',
  'corporateHotel.pricing.plan3.name': 'Two-Day Package',
  'corporateHotel.pricing.plan3.duration': '12 hours (2 days)',
  'corporateHotel.pricing.plan3.note': 'All 6 modules available',
  'corporateHotel.pricing.plan4.name': 'Pre-Opening Intensive',
  'corporateHotel.pricing.plan4.duration': '18 hours (3 days)',
  'corporateHotel.pricing.plan4.note': 'Designed specifically for opening preparation',
  'corporateHotel.pricing.plan5.name': 'Ongoing Programme',
  'corporateHotel.pricing.plan5.duration': 'Half-day once a month × 6 months',
  'corporateHotel.pricing.plan5.note': 'A long-term design built around embedding and improvement',
  'corporateHotel.pricing.conditions.title': 'General Conditions',
  'corporateHotel.pricing.conditions.dispatch': 'Travel and accommodation for on-site delivery charged at cost',
  'corporateHotel.pricing.conditions.capacity': 'Recommended maximum 12 participants (larger groups accommodated in two parallel groups)',
  'corporateHotel.pricing.conditions.payment': 'Payment by invoice (bank transfer). Instalment payments and credit cards are not accepted.',
  'corporateHotel.pricing.conditions.cancel': 'Cancellation policy: Rescheduling is free of charge up to 7 business days before the session. 50% applies from 6 business days prior to the day before; 100% on the day.',
  'corporateHotel.pricing.allMenuNote': 'Ongoing programmes, mystery service audits, and the full menu are available on the',
  'corporateHotel.pricing.allMenuLink': 'Corporate Training page',
  'corporateHotel.pricing.allMenuSuffix': '.',
  'corporateHotel.pricing.ctaBtn': 'Enquire About Training',

  // FlowSteps
  'corporateHotel.flow.label': 'FLOW',
  'corporateHotel.flow.title': 'How It Works',
  'corporateHotel.flow.subtitleEn': 'From Enquiry to Results',
  'corporateHotel.flow.lead': 'We guide you through five clear steps from initial enquiry to post-session report.',
  'corporateHotel.flow.step1.title': 'Initial Enquiry',
  'corporateHotel.flow.step1.desc': 'Contact us via the enquiry form, telephone, or email.',
  'corporateHotel.flow.step2.title': 'Needs Assessment',
  'corporateHotel.flow.step2.desc': 'We discuss participant numbers, challenges, and preferred timing by phone or online. For pre-opening enquiries, please share your target opening date.',
  'corporateHotel.flow.step3.title': 'Programme Proposal & Quotation',
  'corporateHotel.flow.step3.desc': 'Based on the assessment, we propose the most suitable programme for your property and provide a detailed quotation.',
  'corporateHotel.flow.step4.title': 'Delivery',
  'corporateHotel.flow.step4.desc': 'Training is delivered on-site at your property or at our academy. On-site delivery takes place in your actual guest rooms and lounges.',
  'corporateHotel.flow.step5.title': 'Post-Session Report',
  'corporateHotel.flow.step5.desc': 'We provide a written summary of the session and recommendations for further development.',

  // ContactForm
  'corporateHotel.contact.label': 'CONTACT',
  'corporateHotel.contact.title': 'Enquiry',
  'corporateHotel.contact.subtitleEn': 'Enquiry Form',
  'corporateHotel.contact.lead': 'Please complete the form below and submit your enquiry.',
  'corporateHotel.contact.phoneLead': 'You are also welcome to reach us by telephone',
  'corporateHotel.contact.phoneOr': 'or by email',
  'corporateHotel.contact.phoneAlso': '.',
  'corporateHotel.contact.hours': 'Office hours: Monday – Friday 10:00–17:00 JST',
  'corporateHotel.contact.company': 'Property / Company Name',
  'corporateHotel.contact.company.placeholder': 'e.g. Example Hotel',
  'corporateHotel.contact.department': 'Department / Title',
  'corporateHotel.contact.department.placeholder': 'e.g. HR Department, Training Manager',
  'corporateHotel.contact.name': 'Contact Name',
  'corporateHotel.contact.name.placeholder': 'e.g. Taro Butler',
  'corporateHotel.contact.name.required': 'Required',
  'corporateHotel.contact.name.error': 'Contact name is required',
  'corporateHotel.contact.email': 'Email Address',
  'corporateHotel.contact.email.placeholder': 'e.g. taro@example.com',
  'corporateHotel.contact.email.required': 'Required',
  'corporateHotel.contact.email.error': 'Email address is required',
  'corporateHotel.contact.email.invalid': 'Please enter a valid email address',
  'corporateHotel.contact.phone': 'Telephone Number',
  'corporateHotel.contact.phone.placeholder': 'e.g. +81-90-1234-5678',
  'corporateHotel.contact.phone.required': 'Required',
  'corporateHotel.contact.phone.error': 'Telephone number is required',
  'corporateHotel.contact.facilityType': 'Facility Type',
  'corporateHotel.contact.facilityType.required': 'Required',
  'corporateHotel.contact.facilityType.error': 'Please select your facility type',
  'corporateHotel.contact.format': 'Preferred Delivery Format',
  'corporateHotel.contact.participants': 'Estimated Participants',
  'corporateHotel.contact.participants.placeholder': 'e.g. 10',
  'corporateHotel.contact.timeline': 'Preferred Timing',
  'corporateHotel.contact.timeline.placeholder': 'e.g. Next month, 3 months before opening, undecided',
  'corporateHotel.contact.message': 'Message (optional)',
  'corporateHotel.contact.message.placeholder': 'Please share your training objectives, specific requirements, or any questions you have.',
  'corporateHotel.contact.message.error': 'Please keep your message to 500 characters or fewer',
  'corporateHotel.contact.submit.error': 'An error occurred during submission. Please try again or contact us by telephone.',
  'corporateHotel.contact.submit': 'Submit Enquiry',
  'corporateHotel.contact.submitting': 'Sending...',
  'corporateHotel.contact.facilityType.select': 'Please select',
  'corporateHotel.contact.facilityType.cityHotel': 'City Hotel',
  'corporateHotel.contact.facilityType.resort': 'Resort',
  'corporateHotel.contact.facilityType.ryokan': 'Ryokan',
  'corporateHotel.contact.facilityType.preOpening': 'Pre-opening',
  'corporateHotel.contact.format.select': 'Please select',
  'corporateHotel.contact.format.dispatch': 'On-site',
  'corporateHotel.contact.format.onsite': 'At the Academy',
  'corporateHotel.contact.format.undecided': 'Undecided',

  // FAQSection
  'corporateHotel.faq.label': 'FAQ',
  'corporateHotel.faq.title': 'Frequently Asked Questions',
  'corporateHotel.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateHotel.faq.otherNote': 'For further questions, please use the enquiry form',
  'corporateHotel.faq.q1': 'Does this training lead to a butler qualification?',
  'corporateHotel.faq.a1': 'No. This is a business etiquette programme grounded in butler service skills — it does not confer a butler qualification. Certificates of participation are available on request.',
  'corporateHotel.faq.q2': 'Is a pre-opening intensive available?',
  'corporateHotel.faq.a2': 'Yes. We offer a pre-opening intensive spanning three days. The programme can also be spread across several weeks to align with your opening schedule.',
  'corporateHotel.faq.q3': 'Can training take place in our actual guest rooms and lounges?',
  'corporateHotel.faq.a3': 'Yes, our on-site option is available for delivery within your property. Training in your actual layout improves reproducibility from the very next shift.',
  'corporateHotel.faq.q4': 'Is training available in English?',
  'corporateHotel.faq.a4': 'Sessions are conducted in Japanese. If you would like to include English hospitality phrases for interacting with overseas guests, please let us know during the needs assessment.',

  // CTASection
  'corporateHotel.cta.label': 'GET STARTED',
  'corporateHotel.cta.title': 'We Would Love to Hear From You',
  'corporateHotel.cta.lead': 'Tell us about your property\'s challenges and we will propose the most suitable training plan — at no charge.',
  'corporateHotel.cta.lead2': 'We are happy to discuss a training plan working back from your opening date. Even a rough target date is enough to get started.',
  'corporateHotel.cta.inquiryBtn': 'Enquire for This Sector',
  'corporateHotel.cta.coursesBtn': 'Browse Individual Courses',

  // RelatedPages
  'corporateHotel.related.label': 'OTHER INDUSTRIES',
  'corporateHotel.related.title': 'Other Industry Programmes',
  'corporateHotel.related.subtitleEn': 'Other Industry Programmes',
  'corporateHotel.related.viewDetail': 'Learn More',
  'corporateHotel.related.backToCorpBtn': 'Back to Corporate Training',
  'corporateHotel.related.coursesBtn': 'Browse Individual Courses (Butler Training Programme)',
  'corporateHotel.related.r1.title': 'Luxury Residences',
  'corporateHotel.related.r1.desc': 'Consistent concierge and front-desk service quality',
  'corporateHotel.related.r2.title': 'Private Banking & Finance',
  'corporateHotel.related.r2.desc': 'Build client trust through refined conduct',
  'corporateHotel.related.r3.title': 'Department Stores & Luxury Retail',
  'corporateHotel.related.r3.desc': 'Preferred client care and the art of the visit',
  'corporateHotel.related.r4.title': 'Luxury Sales',
  'corporateHotel.related.r4.desc': 'Designing the client experience for high-value transactions',
  'corporateHotel.related.r5.title': 'Aesthetic Medicine & Private Clinics',
  'corporateHotel.related.r5.desc': 'Embedding premium service culture in a clinical environment',
  'corporateHotel.related.r6.title': 'Automotive & Mobility',
  'corporateHotel.related.r6.desc': 'Elevating the brand experience',
  'corporateHotel.related.r7.title': 'Chauffeur & Transfer Services',
  'corporateHotel.related.r7.desc': 'Perfecting door etiquette and in-vehicle attentiveness',
};

export default corporateHotel;
